import service from '@/utils/request'

export const getuLandPageList = (data) => {
  return service({
    url: '/uLandPage/getLandPageList',
    method: 'post',
    data
  })
}

export const updateuLandPage = (data) => {
  return service({
    url: '/uLandPage/updateLandPage',
    method: 'post',
    data
  })
}

export const deluLandPage = (data) => {
  return service({
    url: '/uLandPage/delLandPage',
    method: 'post',
    data
  })
}

export const adduLandPage = (data) => {
  return service({
    url: '/uLandPage/addLandPage',
    method: 'post',
    data
  })
}



